/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "portal": {
        "nested": {
          "service_error": {
            "nested": {
              "SubmitPortalTransactionErrorType": {
                "values": {
                  "DEFAULT_CREATION_ERROR_DO_NOT_USE": 0,
                  "INVALID_REQUEST": 1,
                  "INVALID_STATE": 2,
                  "INTERNAL_ERROR": 3,
                  "AMOUNT_TOO_LOW": 4,
                  "TERMINAL_TRANSACTION_ALREADY_ENQUEUED": 5
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.portal?.nested?.service_error?.nested?.SubmitPortalTransactionErrorType) {
  $root.addJSON(jsonData);
}

/**
 * Enum of the submit portal transaction error types.
 *
 * SOURCE SubmitPortalTransactionErrorType @ squareup/portal/service_error.proto at 10:1
 */
export const SubmitPortalTransactionErrorType = $root.lookupEnum('squareup.portal.service_error.SubmitPortalTransactionErrorType').values;